import { BROWSER_SESSION } from '~/types'

import type { WithOptions } from '../useInternalApi'

import { useInternalApi } from '../useInternalApi'

export type TemplateCollectionData = App.Http.InternalApi.BrowsingSession.Data.Template.TemplateCollectionData

export const useFetchCollection = () => {
  const { getMany, getUrl } = useInternalApi()

  const getAll = ({ options }: WithOptions = {}) =>
    getMany<TemplateCollectionData[]>({
      url: getUrl(BROWSER_SESSION, 'template-collections'),
      accessType: BROWSER_SESSION,
      options: {
        params: {
          per_page: 100,
        },
        ...options,
      },
    })

  return {
    getAll,
  }
}
